import { useLazyQuery, useMutation, useQuery } from "@apollo/client";

import {
    GET_STAND_COMMENT,
    GET_STAND_COMMENTS
} from "graphql/query/comment-gql";
import {
    STAND_ATTACHMENT_CREATE,
    STAND_ATTACHMENT_DELETE,
    STAND_COMMENT_CREATE,
    STAND_COMMENT_DELETE,
    STAND_COMMENT_UPDATE
} from "graphql/mutation/comment-gql";

const useStandCommentsApi = ({ standId }) => {
    const where = {
        column: "MODELABLE_TYPE",
        operator: "EQ",
        value: "STAND",
        AND: [
            {
                column: "MODELABLE_ID",
                operator: "EQ",
                value: standId
            }
        ]
    };

    const commentsQuery = useQuery(GET_STAND_COMMENTS, {
        variables: {
            where,
            orderBy: [
                {
                    column: "CREATED_AT",
                    order: "DESC"
                }
            ],
            first: 100
        },
        fetchPolicy: "cache-and-network",
        notifyOnNetworkStatusChange: true
    });

    const [ getComment, getCommentResult ] = useLazyQuery(GET_STAND_COMMENT, {
        fetchPolicy: "network-only"
    });
    const [ createComment, createCommentResult ] = useMutation(STAND_COMMENT_CREATE);
    const [ updateComment, updateCommentResult ] = useMutation(STAND_COMMENT_UPDATE);
    const [ deleteComment, deleteCommentResult ] = useMutation(STAND_COMMENT_DELETE);
    const [ createAttachment, createAttachmentResult ] = useMutation(STAND_ATTACHMENT_CREATE);
    const [ deleteAttachment, deleteAttachmentResult ] = useMutation(STAND_ATTACHMENT_DELETE);

    return {
        where,
        commentsQuery,
        getComment,
        getCommentResult,
        createComment,
        createCommentResult,
        updateComment,
        updateCommentResult,
        deleteComment,
        deleteCommentResult,
        createAttachment,
        createAttachmentResult,
        deleteAttachment,
        deleteAttachmentResult
    };
};

export default useStandCommentsApi;
